import React, { useState, useEffect } from 'react';
// import ReactDOMServer from 'react-dom/server';
import { isMobile } from "../../common/util";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import OutboundICON from '../../icons/OutboundICON';
import { Outlet } from 'react-router-dom';
import { useModules } from '../../utils/modules';
import TopHeaderRight from '../TopHeaderRight';
import LeftNav from '../LeftNav';
// import FieldRenderingEngine from "../FieldRenderingEngine";
import Icon from '../../icons';
import { RightPanelConstant, RenderEngineKey, DiariesConstants } from '../../containers/WorkkardDetail/constants';
import { toggleView, setPanelVisibility } from "../../containers/WorkkardDetail/actions/action";
import { setActiveTopHeader, fetchUserOrgNameSuggestions, setPartyAssociation } from '../../containers/Header/actions/action';
import { copyTextToClipboard, getNavItem, clearProfileHash } from '../../common/util';
import { showDialogueBox, hideDialogueBox } from '..//DialogueBox/actions';
import ManageProfile from "../../containers/Header/ManageProfile";
import { toggleDiaryView, resetViewData, resetListingData } from "../../containers/Diaries/actions";
import { SeturlHash } from '../../containers/WorkkardDetail/utils';
import CreationForms from "../../containers/CreationForms";
import { useLegacyHistory } from '../../router/hooks';
import { selectSessionContextOidc } from '@container/AdminPanel/features/users/usersSelectors';

const HeaderTemplate = (props) => {

    const dispatch = useDispatch();
    const { isModuleEnabled, moduleLabel } = useModules();
    const { location, history } = useLegacyHistory();
    const sessionContext = useSelector(selectSessionContextOidc);
    const userView = sessionContext?.userView;
    const userPermissions = userView?.permissions;
    const { workkard, currentView, diariesView, panelVisibility, nav } = useSelector(state => ({
        workkard: state.workkardDetail.workkardDetail,
        currentView: state.workkardDetail.panelVisibility.toggleView,
        sessionContext: state.sessionContext,
        diariesView: state.diaries.view.view,
        panelVisibility: state.workkardDetail.panelVisibility,
        nav: state.sessionContext?.navigation
    }), shallowEqual);

    const [isCopySuccess, setCopySuccess] = useState(false);
    const [showLeftPanel, setShowLeftPanel] = useState(false);

    let middleColClass = "";

    const onClickCopy = (text) => {
        copyTextToClipboard(text, () => {
            setCopySuccess(true)
        });
    };

    const addPartyModalEvent = (e) => {
        if (!isModuleEnabled("parties")) return;
        if ($(".headerRight li").is('[name]')) {
            $(".headerRight li").removeAttr("name");
        }
        dispatch(setPartyAssociation(e.detail && e.detail.type ? e.detail.type : 'workkard'))
        dispatch(setActiveTopHeader({ activeHeader: 'createAssociatedParties' }));
        $(`#partyGlobalIcon`).attr('name', 'parties');
    };

    useEffect(() => {
        if (sessionContext && userView) {
            dispatch(fetchUserOrgNameSuggestions({ email: userView.email }));
        }
        const urlHash = window.location.hash;
        if (urlHash === "#profile") {
            dispatch(showDialogueBox({
                flag: true,
                component: <ManageProfile onClose={() => { dispatch(hideDialogueBox()); clearProfileHash(history); }} />,
                overlayClassName: "modal animated faster fadeIn",
                contentClassName: "modalContent globalSearchModalContent modalFixed animated faster fadeInUpx2 medium",
                shouldCloseOnOverlayClick: true
            })
            )
        }
        window.addEventListener('addPartyModalEvent', (e) => { addPartyModalEvent(e) });
    }, [userView]);

    const getLeftHeaderHTML = (controller, action) => {
        // Copy workkard numbver and insured name
        const workkardNumber = workkard.WorkkardNumber;

        // Direct field lookup — avoids ReactDOMServer.renderToString + FieldRenderingEngine
        const customerNameFields = workkard.CustomFields
            ? workkard.CustomFields.filter(f => f.FieldGroup === RenderEngineKey.CustomerName)
            : [];
        let customerName = '';
        if (customerNameFields.length) {
            const firstField = customerNameFields[0];
            const groupType  = (firstField.Group || '').toLowerCase();
            if (groupType === 'name') {
                const first = customerNameFields.find(f => f.Name && f.Name.toLowerCase().includes('firstname'))?.Value || '';
                const last  = customerNameFields.find(f => f.Name && f.Name.toLowerCase().includes('lastname'))?.Value  || '';
                customerName = (first && last) ? `${last}, ${first}` : (first || last);
            } else {
                customerName = firstField.Value || '';
            }
        }
        let tooltipText, copyText = customerName.trim().length ? `${workkardNumber} - ${customerName}` : workkardNumber;
        copyText = $("<div/>").html(copyText).text() //it is a hotfix, need to handle decoding EC-59245
        if (isCopySuccess) {
            tooltipText = "Copied!"
        } else {
            if (customerName.trim().length) {
                tooltipText = moduleLabel("workkards.header.copy_number_and_name", "Copy Workkard Number and Insured Name")
            } else {
                tooltipText = "Copy Workkard Number"
            }
        }

        var headerHTML = ""
        const pathName = location.pathname.replace('/', '')
        const isViewsSelected = pathName.toLowerCase().startsWith('view')
            || pathName.toLowerCase().startsWith(String(getNavItem(nav, "views", 0)).toLowerCase());
        if (isViewsSelected) {
            $('.headerLeft').attr("data-test", `headerLeft views`);
            return null;
        } else if (["activities", getNavItem(nav, "activities"), "workkards", getNavItem(nav, "workkards")].includes(pathName)) {
            $('.headerLeft').attr("data-test", `headerLeft ${pathName}`);
            return <h1>{pathName.toCapitalize()}</h1>
        } else if (/^\/workkards\/create$/.test(location.pathname)) {
            $('.headerLeft').attr("data-test", `headerLeft createWorkkard`);
            return <h1>Create a new Workkard</h1>
        } else if (/^\/workkards\/edit\//.test(location.pathname)) {
            $('.headerLeft').attr("data-test", `headerLeft editWorkkard`);
            return <h1>Edit Workkard</h1>
        } else if (/\/activity\/create$/.test(location.pathname)) {
            $('.headerLeft').attr("data-test", `headerLeft createActivity`);
            return <h1>Create a new activity</h1>
        } else if (/\/activity\/edit\//.test(location.pathname)) {
            $('.headerLeft').attr("data-test", `headerLeft editActivity`);
            return <h1>Edit Activity</h1>
        } else if (pathName === "getclmdetail" || pathName === "gad") {
            $('.headerLeft').attr("data-test", `headerLeft detailPage`);
            let workkardStatusClass = (workkard && workkard.WorkkardStatusForDisplay || '').toLowerCase();
            let WorkkardReopenReason = workkard && workkard.WorkkardReopenReason;
            let isLitTPAClaimExistForGTPAWkd =workkard && workkard.litClaimStatusForWorkkard!="" ? true :false;
            let litClaimStatus= isLitTPAClaimExistForGTPAWkd==true ? workkard.litClaimStatusForWorkkard :"";
            let litClaimText= workkard && workkard.litClaimStatusForWorkkard && workkard.litClaimStatusForWorkkard!="" ? `Lawsuit (${litClaimStatus})` :"";
            let objPermissions  = userView?.ReviewSystemPermissions && JSON.parse(userView.ReviewSystemPermissions);
            let isreviewdashboard  = objPermissions  && objPermissions.hasOwnProperty("permissions") ?  objPermissions.permissions.find(({ name }) => name === "Can View Review Tab")?.is_checked: false;
            return <>
                <div className="mr alignMiddle flexGrow wkDetailNumber">
                    <span className="badges wkSymbol wkSymbolFilled mr">{getNavItem(nav, "workkards", 1).charAt(0)}</span>
                    <span className="mr number">{workkardNumber}</span>
                    <span className={"mr status statusFilled " + workkardStatusClass + " " + workkardStatusClass + "Filled workkardStatus"}>
                        {workkardStatusClass}{WorkkardReopenReason ? ` (${WorkkardReopenReason}${workkard.WorkkardReopenSubReason ? ` - ${workkard.WorkkardReopenSubReason}`:''})` : ''}
                    </span>
                   {litClaimStatus!=undefined && litClaimStatus!=""  && <span className = {"mr status statusFilled law  lawFilled workkardStatus"}>
                    <strong>{litClaimText}</strong>
                    </span>}

                    {workkardNumber &&
                     <span onMouseLeave={() => { !isMobile() && setCopySuccess(false)}}  className={`${isMobile() ? "" : "copyText"}
                      quickTooltip-bottom selfStart alignMiddle animated fast fadeInLeftSmall ${isCopySuccess ? 'copySuccess' : ''}`} data-quicktooltip={tooltipText} >
                        <span className="" onClick={() => onClickCopy(copyText)} ><Icon name="copy" className="icon" /></span>
                    </span>}
                </div>
                <div className="tabNav stickyNav tabOnlyActive tabHeader mobStickyFooter">
                      <div  className="tabs stickyTab rowSpaceBetween" data-test={`deatilPage ${currentView.toLowerCase()}`}>
                        <span className='tabLetterMob tabLetterLeft'>
                        <a type="activities" onClick={() => { subHeaderClicked(RightPanelConstant.NormalView) }} className={`pointer ${currentView.toLowerCase() === RightPanelConstant.NormalView.toLowerCase() ? "active" : ""}`}>Activities</a>
                        <a type="combined view" onClick={() => { subHeaderClicked(RightPanelConstant.CombinedViewText) }} className={`pointer ${currentView.toLowerCase() === RightPanelConstant.CombinedViewText.toLowerCase() ? "active" : ""}`}>Combined View</a>
                        </span>
                        {/* Workkard Action Button to load right panel of workkard     */}
                        <a className="WorkkardAction" onClick={() =>dispatch(setPanelVisibility({ showWkInMobileView: true })) }>W</a>

                        <span className='tabLetterMob'>
                        {userView && userPermissions.can_access_financials && !workkard.IsSysUserCreated && isModuleEnabled("workkards.financial") &&
                            <a type="financials" onClick={() => { subHeaderClicked(RightPanelConstant.FinancialView) }} className={`pointer ${currentView.toLowerCase() === RightPanelConstant.FinancialView.toLowerCase() ? "active" : ""}`}>Financials</a>
                        }
                        {userView && userPermissions.can_request_for_letter && isModuleEnabled("workkards.letters") &&
                            <a type="letter" onClick={() => { subHeaderClicked(RightPanelConstant.LettersView) }} className={`pointer ${currentView.toLowerCase() === RightPanelConstant.LettersView.toLowerCase() ? "active" : ""}`}>Letters</a>
                        }
                        {userView && userView.CanAccessReviewSystem && isreviewdashboard && isModuleEnabled("workkards.review_system") &&
                            <a type="review" onClick={() => { subHeaderClicked(RightPanelConstant.ReviewsView) }} className={`pointer ${currentView.toLowerCase() === RightPanelConstant.ReviewsView.toLowerCase() ? "active" : ""}`}>Review</a>
                        }
                        </span>
                    </div>
                </div>
            </>
        } else if (pathName === "tdo" || pathName === "dtdo") {
            return <>
                <div className="mr alignMiddle flexGrow">Diaries</div>
                <div id="todoTabs" className="tabNav tabOnlyActive tabHeader">
                    <div className="tabs">
                        <a id="listView" onClick={() => { diariesView === "list" ? () => { return false } : subHeaderClicked(DiariesConstants.list) }} name="list" className={`pointer workkard_tab workkardStatus ${diariesView === "list" ? 'active' : ''}`}>List<span></span></a>
                        <a id="dayView" onClick={() => { diariesView === "day" ? () => { return false } : subHeaderClicked(DiariesConstants.day) }} name="day" className={`pointer workkard_tab workkardStatus ${diariesView === "day" ? 'active' : ''}`}>Week<span></span></a>
                        <a id="monthView" onClick={() => { diariesView === "month" ? () => { return false } : subHeaderClicked(DiariesConstants.month) }} name="month" className={`pointer workkard_tab workkardStatus ${diariesView === "month" ? 'active' : ''}`}>Month<span></span></a>
                    </div>
                </div>
            </>
        }
        else if (action == "Create" && controller == "Activity") {
            $('.headerLeft').attr("data-test", `headerLeft createActivity`);
            headerHTML = <h1>Create a new activity</h1>
        }
        else if (action == "Edit" && controller == "Activity") {
            $('.headerLeft').attr("data-test", `headerLeft editActivity`);
            headerHTML = <h1>Edit Activity</h1>
        }
        else if (action == "Clone" && controller == "ActivityClone") {
            $('.headerLeft').attr("data-test", `headerLeft cloneActivity`);
            headerHTML = <h1>Create a new activity</h1>
        }
        else if (controller == "Workkard" && action == "Create") {
            $('.headerLeft').attr("data-test", `headerLeft createWorkkard`);
            headerHTML = <h1>Create a new Workkard</h1>
        }
        else if (action == "Edit" && controller == "Workkard") {
            $('.headerLeft').attr("data-test", `headerLeft editWorkkard`);
            headerHTML = <h1>Edit Workkard</h1>
        }
        else if (controller == "UserProfile" && action == "UserProfile") {
            //ToDo
        }
        else if (controller == "User") {
            $('.headerLeft').attr("data-test", `headerLeft user`);
            headerHTML = <h1>Manage Users</h1>
        }
        else if (controller == "Relationship") {
            $('.headerLeft').attr("data-test", `headerLeft manageRelationships`);
            headerHTML = <h1>Manage Relationships</h1>
        }
        else if (controller == "SpockView" || controller == "Spock") {
            return null
        }
        else if (controller.toString() == "search") {
            //ToDo
        }
        else if (controller.toString().toLowerCase() == "inbox") {
            middleColClass = "inbox_container inbox_left_layout";
            $('.headerLeft').attr("data-test", `headerLeft inbox`);
            let pgHeader=window.location.pathname.toLowerCase().includes('bulkinbox')?"Bulk Inbox":"Inbox";
            headerHTML = <div className="sub_nav"> <div className="top_bar"> <h1>{pgHeader}</h1> </div> </div>
        }
        else if (controller.toString().toLowerCase() == "mercury") {
            $('.headerLeft').attr("data-test", `headerLeft mercury`);
            let pgHeader=window.location.pathname.toLowerCase().includes('dashboard')?"Dashboard":(window.location.pathname.toLowerCase().includes('mb')?"Outbound":(window.location.pathname.toLowerCase().includes('mrc')?"Review Center":"Mercury"));
            if(pgHeader==="Outbound")
            {
                headerHTML = <div className="sub_nav"> <div className="top_bar alignMiddle "><OutboundICON className="icon "/> &nbsp;&nbsp;<h1> {pgHeader} <span id="mailcounter">(0)</span> </h1></div> </div>
            }
            else
            {
                headerHTML = <div className="sub_nav"> <div className="top_bar"> <h1>{pgHeader}</h1> </div> </div>
            }
            
        }
        else if (controller.toString().toLowerCase() == "dynamic" || pathName.includes('financial')) {
            let dataTest = `headerLeft ${controller.toString().toLowerCase() == "dynamic" ? "dynamic" : 'financial'}`;
            $('.headerLeft').attr("data-test", dataTest);
            var headingText = "";
            if (action.toString().toLowerCase() == "index") {
                middleColClass = "middle_col mn_approval_ctr";
                headingText = "Pending Approvals";
            }
            else if (action.toString().toLowerCase() == "getaccountingpage") {
                middleColClass = "middle_col mn_approval_ctr";
                headingText = "IA Accounting";
            }
            else if (pathName.includes("letters")) {
                headingText = "Letters"
            }
            headerHTML = <div className="sub_nav"> <div className="top_bar"> <h1>{headingText}</h1> </div> </div>
        }
        else {
            headerHTML = <h1><a href="/workkards">Create a new Workkard</a></h1>
        }
        return headerHTML;
    }

    const subHeaderClicked = (viewType) => {
        switch (viewType) {
            case RightPanelConstant.NormalView:
                dispatch(toggleView(RightPanelConstant.NormalView))
                return dispatch(setPanelVisibility({
                    isLeftVisible: panelVisibility.isNoteVisible ? false : true,
                    isMiddleVisible: true,
                    isVisibleExternalApp: false,
                    toggleView: RightPanelConstant.NormalView
                }))
            case RightPanelConstant.CombinedViewText:
                dispatch(toggleView(RightPanelConstant.CombinedViewText))
                return dispatch(setPanelVisibility({
                    isLeftVisible: panelVisibility.isNoteVisible ? false : true,
                    isMiddleVisible: true,
                    isVisibleExternalApp: false,
                    toggleView: RightPanelConstant.CombinedViewText
                }))

            case RightPanelConstant.FinancialView:
            case RightPanelConstant.LettersView:
            case RightPanelConstant.ReviewsView:
                return dispatch(toggleView(viewType.toLowerCase()))
            case DiariesConstants.day:
            case DiariesConstants.month:
            case DiariesConstants.list:
                SeturlHash(false, null, null, history, viewType.toLowerCase(), true);
                dispatch(resetListingData());
                dispatch(resetViewData());
                return dispatch(toggleDiaryView({ view: viewType.toLowerCase() }))
            default:
                return null;
        }
    }

    const controller = document.getElementById('requestController') ? document.getElementById('requestController').value : ""
    const action = document.getElementById('requestAction') ? document.getElementById('requestAction').value : ""

    // Agreement and Privacy Policy pages render without the app header, left nav and creation forms
    const isStandalonePage = /^\/(agreement|privacypolicy)(\/|$)/i.test(location.pathname);

    if (isStandalonePage) {
        return <Outlet />;
    }

    return (
        <>
            <div className="header">
                <div className="headerMain">
                    <div className="headerLeft" data-test="">
                        {getLeftHeaderHTML(controller, action)}
                    </div>
                    <TopHeaderRight
                        onHamburgerClick={(value) => {
                        setShowLeftPanel(value);
                        }}
                    />
                </div>
            </div>
            <LeftNav
                showLeftPanel={showLeftPanel}
                setShowLeftPanel={(value) => setShowLeftPanel(value)}
            />
            <CreationForms />
            <Outlet />
        </>
    );
}

export default HeaderTemplate;